/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { ImageFieldDisplay } from "./display";
import { ImageFieldEdit } from "./edit";

const ImageField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <ImageFieldDisplay />,
        editComponent: <ImageFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
ImageField.displayName = "ImageField";
export { ImageField };
